module.exports = __webpack_public_path__ + "static/media/section.b0641d20.svg";